import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Button } from '../Button/Button'

import './ButtonDropDown.scss'

export const ButtonDropDown = ({ items, className, callback, propsButton, isOnTop }) => {
  const ref = useRef(null)

  const [open, setOpen] = useState(false)

  const containerClasses = classNames(className, 'dropdown table-header_dropdown', {
    'open': open
  })

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
  })

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false)
    }
  }

  const handleClick = (index, command, descending) => {
    // items.forEach(function(i){
    //     i.selected = false;
    // })
    callback(index, command, descending)
  }

  if (!items) {
    return null
  }

  const renderItem = (item, i) => {
    if (item.separator) {
      return <li className={classNames('c-dropdown-menu__element-separator', item.className)} />
    } else {
      return <li className='c-dropdown-menu__element'><a className={classNames('c-dropdown-menu__element__link', item.className)} onClick={() => handleClick(i, item.command, item.descending)}>{item.label}</a></li>
    }
  }

  const ddClassname = classNames('c-dropdown-menu', {
    'c-dropdown-menu--open': open,
    'c-dropdown-menu--on-top': isOnTop
  })

  return (

    <div className={containerClasses} onClick={() => setOpen(!open)} ref={ref}>

      <Button {...propsButton} />
      <ul className={ddClassname}>
        {items.map((item, i) => renderItem(item, i))}
      </ul>

    </div>
  )
}

ButtonDropDown.defaultProps = {
  isOnlyText: true
}

ButtonDropDown.propTypes = {

  icon: PropTypes.string,
  callback: PropTypes.func,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    command: PropTypes.string,
    className: PropTypes.string
  }))
}
